export default __webpack_public_path__ + "static/media/inner-data-driven-maintenance.3e1279bc.svg";